import './menu-profile.scss';

/* global swal, t */

/**
 * Menu profile component - handles profile list in sidebar
 */
export default () => {
	const element = document.querySelector( '[data-component="menu-profile"]' );

	if ( !element ) return;

	const config = element.dataset.config ? JSON.parse( element.dataset.config ) : {
	};
	const profileHandle = config.profileHandle || '';

	let orderColumn = $( '.domain-menu .domain__caption .domain__col[data-sort-default="1"]' ).data( 'sort' );
	let sortOrder = $( '.domain-menu .domain__caption .domain__col[data-sort-default="1"]' ).data( 'sortorder' );

	/**
	 * Reset the profiles form
	 */
	function resetProfilesForm () {
		$( '.profiles-table' ).empty();
	}

	/**
	 * Load profiles via AJAX
	 * @param {jQuery|string} searchForm - Optional search form element
	 */
	function loadProfiles ( searchForm = '' ) {
		resetProfilesForm();

		let searchPhrase = '';

		if ( searchForm ) {
			searchPhrase = $( searchForm ).find( 'input[name=input_search]' ).val();
		}

		$.ajax( {
			type: 'POST',
			dataType: 'json',
			url: '/cp/modules/domains/json/load-profiles.php',
			data: {
				search_phrase: searchPhrase,
				sort: {
					column: orderColumn,
					sortorder: sortOrder,
				},
			},
			success: function ( data ) {
				$.each( data.details.profiles, function ( key, profile ) {
					$( '.profiles-table' ).append( `
						<div class="domain__item position-relative ${profileHandle === profile.handle ? 'is-active' : ''}">
							<div class="d-flex flex-wrap mx-n2">
								<a class="domain__col domain__col--domain align-items-center px-2" href="/cp/domains/profiles/${profile.handle}/">
									<div class="d-flex align-self-start">
										<div>
											<i class="fas fa-user"></i> 
										</div>
										<div>
											<div>${profile.alias}${profile.trustee ? ' <span class="badge bg-secondary">Trustee (.no)</span>' : ''}</div>
										</div>
									</div>
								</a>
								<div class="domain__col domain__col--date px-2">${profile.company}</div>
								<div class="domain__col px-2">${profile.name}</div>
							</div>
							<a href="" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="domain__edit">
								<i class="fas fa-ellipsis-v"></i>
							</a>
							<div class="dropdown-menu">
								<a class="dropdown-item" href="/cp/domains/profiles/${profile.handle}/">${t( 'Aanpassen' )}</a>
								<a class="dropdown-item text-danger remove-profile" data-handle="${profile.handle}" href="#">${t( 'Verwijderen' )}</a>
							</div>
						</div>
					` );
				} );
			},
			error: function ( xhr ) {
				$.toast( {
					heading: t( 'Foutmelding' ),
					text: $.parseJSON( xhr.responseText ).status_description,
					position: 'bottom-left',
					loaderBg: '#87888a',
					icon: 'error',
					hideAfter: 6000,
					stack: 6,
				} );
			},
		} );
	}

	// Search form submission.
	$( '.search-form' ).on( 'submit', function ( e ) {
		const searchForm = $( this );

		e.preventDefault();
		loadProfiles( searchForm );
	} );

	// Remove profile handler.
	$( document ).on( 'click', '.remove-profile', function () {
		const curThis = $( this );
		const handle = $( this ).data( 'handle' );

		swal( {
			title: t( 'Zeker weten?' ),
			text: t( 'Weet je zeker dat je dit domeinprofiel wilt verwijderen?' ),
			icon: 'warning',
			buttons: [
				t( 'Nee' ),
				t( 'Ja' ),
			],
		} ).then( function ( isConfirm ) {
			if ( isConfirm ) {
				const loading = $.toast( {
					heading: t( 'Aanvraag in uitvoering' ),
					text: t( 'Bezig met uitvoeren...' ),
					position: 'bottom-left',
					loaderBg: '#87888a',
					icon: 'info',
					hideAfter: false,
					stack: 6,
					allowToastClose: true,
				} );

				$.ajax( {
					type: 'POST',
					dataType: 'json',
					url: '/cp/modules/domains/json/deleteprofile.php',
					data: {
						handle: handle,
					},
					success: function ( data ) {
						$( curThis ).closest( '.domain__item' ).remove();

						loading.reset();
						$.toast( {
							heading: t( 'Succesvol' ),
							text: data.status_description,
							position: 'bottom-left',
							loaderBg: '#87888a',
							icon: 'success',
							hideAfter: 6000,
							stack: 6,
						} );
					},
					error: function ( xhr ) {
						loading.reset();
						$.toast( {
							heading: t( 'Foutmelding' ),
							text: $.parseJSON( xhr.responseText ).status_description,
							position: 'bottom-left',
							loaderBg: '#87888a',
							icon: 'error',
							hideAfter: 6000,
							stack: 6,
						} );
					},
				} );
			}
		} );
	} );

	// Sorting handler.
	$( '.domain-menu .domain__caption .domain__col' ).click( function () {
		// Reset all sorting.
		$( '.domain-menu .domain__caption .domain__col' ).not( this ).data( 'sortorder', '' );
		$( '.domain__caption .domain__col .sort i' ).removeClass( 'active' );

		orderColumn = $( this ).data( 'sort' );
		sortOrder = $( this ).data( 'sortorder' ) === 'asc' ? 'desc' : 'asc';

		$( this ).data( 'sortorder', sortOrder );
		$( this ).find( `.sort .${sortOrder}` ).addClass( 'active' );

		loadProfiles();
	} );

	// Load profiles on page load.
	loadProfiles();
};

